// @mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";

// ----------------------------------------------------------------------

type NotificationItemProps = {
  notification: {
    id: number;
    message: string;
    read: boolean;
  };
};

export default function NotificationItem({ notification }: NotificationItemProps) {
  const renderText = (
    <ListItemText
      disableTypography
      primary={reader({ notification })}
      secondary={
        <Stack
          direction="row"
          alignItems="center"
          sx={{ typography: "caption", color: "text.disabled" }}
          divider={
            <Box
              sx={{
                width: 2,
                height: 2,
                bgcolor: "currentColor",
                mx: 0.5,
                borderRadius: "50%",
              }}
            />
          }
        ></Stack>
      }
    />
  );

  return (
    <ListItemButton
      disableRipple
      sx={{
        p: 2.5,
        py: 1.5,
        alignItems: "flex-start",
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
      }}
    >
      <Stack sx={{ flexGrow: 1 }}>{renderText}</Stack>
    </ListItemButton>
  );
}

// ----------------------------------------------------------------------

function reader({ notification }: NotificationItemProps) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: notification.message }}
      sx={{
        mb: 0.5,
        "& p": { typography: "body2", m: 0 },
        "& a": { color: "inherit", textDecoration: "none" },
        "& strong": { typography: "subtitle2" },
        fontWeight: `${!notification.read ? "bold" : ""}`,
      }}
    />
  );
}
